document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');

    quantityWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('[data-quantity-input]');
      const minusButton = wrapper.querySelector('[data-quantity-minus]');
      const plusButton = wrapper.querySelector('[data-quantity-plus]');

      if (!input || !minusButton || !plusButton) return;

      function updateQuantity(newValue) {
        // Allow 0 as a valid quantity
        newValue = Math.max(0, parseInt(newValue) || 0);
        input.value = newValue;
        
        // Trigger the input event to update cart
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);

        // If there's a form, submit it
        const form = input.closest('form');
        if (form) {
          form.dispatchEvent(new Event('submit', { bubbles: true }));
        }
      }

      minusButton.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue - 1);
      });

      plusButton.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue + 1);
      });

      // Handle manual input
      input.addEventListener('change', () => {
        updateQuantity(input.value);
      });

      // Prevent form submission on button click
      minusButton.addEventListener('submit', (e) => e.preventDefault());
      plusButton.addEventListener('submit', (e) => e.preventDefault());
    });
  }, 200);
}); 